import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Bind, Debounce } from 'lodash-decorators';
import cx from 'classnames';

// Styles.
import styles from './styles.module.scss';

// Images.
import { ReactComponent as Success } from './images/success.svg';
import { ReactComponent as Error } from './images/error.svg';

export default class AlertMessage extends Component {

  constructor() {
    super();

    this.state = {
      isShow: true,
    };
  }

  static propTypes = {
    message: PropTypes.string.isRequired,
    status: PropTypes.string,
  };

  static defaultProps = {
    status: 'normal',
  };


  componentDidMount() {
    this.onClose();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.message !== nextProps.message && nextProps.message.length > 0) {
      this.setState({ isShow: true });
    }
  }

  @Bind()
  @Debounce(3000)
  onClose() {
    this.setState({ isShow: false }, () => {
      this.props.clearAlertMessage();
    });
  }

  onClickClose = () => {
    this.setState({ isShow: false });
  };

  render() {
    const { message, status } = this.props;
    const { isShow } = this.state;

    if (!isShow) {
      return null;
    }
    let image = <Success />;
    if (status === 'error') {
      image = <Error />;
    }

    return (
      <div className={cx(styles.alertMessage)} onClick={this.onClickClose}>
        {image}
        <span className={styles.message}>{message}</span>
      </div>
    );
  }
}
